<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Compras/ Pedido Compra Local</label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            color="info"
            to="/pedidoAvulso/criar"
            v-if="isAllowed(21)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            >
            <v-radio value="PG">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">PG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Pedido Gerado</div>
              </template>
            </v-radio>
            <v-radio value="EP">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">EP</span>
                </v-avatar>
                <div class="ma-1 text-h5">Entrada Parcial</div>
              </template>
            </v-radio>
            <v-radio value="B">
              <template v-slot:label>
                <v-avatar color="blue-grey lighten-4" size="25">
                  <span class="white--text text-h6">B</span>
                </v-avatar>
                <div class="ma-1 text-h5">Baixado</div>
              </template>
            </v-radio>
            <v-radio value="I">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativa</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="text-right">
          <!--<v-btn
            @click="baixarlista()"
            v-if="pedidos.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>-->
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              :max="new Date().toISOString().substr(0, 10)"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'PG'" color="green" size="24">
            <span class="white--text text-h5">PG</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'EP'" color="yellow" size="24">
            <span class="white--text text-h5">EP</span>
          </v-avatar>
          <v-avatar
            v-else-if="item.status == 'B'"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">B</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.data="{ item }">
          <span>{{
            new Date(item.data).toLocaleString().replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
        <template v-slot:item.total="{ item }">
          <span>{{ money(item.total) }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!pedidoPodeSerEditado(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(21)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
          <v-tooltip v-if="isInactive(21)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="inativar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!pedidoPodeSerInativado(item)"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Inativar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getPdf } from "../../../services/pedidoAvulsoService";
import { canInactivateModule, getUserRoles, isLoggedUserAdmin } from "@/services/loginService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import moment from "moment";

export default {
  name: "listaPedidosAvulso",
  data() {
    return {
      loading: false,
      selectedFilter: "0",
      apenasLeitura: false,
      search: "",
      showAtivo: false,
      active_tab: 2,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      headers: [
        {
          text: "Pedido",
          align: "start",
          value: "id",
        },
        { text: "Data", value: "data" },
        { text: "Unidade", value: "unidadeAdm" },
        { text: "Comprador", value: "comprador" },
        { text: "Valor", value: "total" },
        { text: "Status", value: "status" },
        { text: "", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        unidadeAdm: [],
        comprador: [],
      },
    };
  },
  computed: {
    ...mapState("pedidoAvulso", ["pedidosAvulso"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    ...mapState("fornecedor", ["fornecedores"]),
    filteredList() {
      const searchLower = this.search.toLowerCase();

      return this.pedidosAvulso
        .filter((pa) => {
          // 1. Filtro por texto digitado
          const buscaTexto =
            pa.id.toString().toLowerCase().includes(searchLower) ||
            pa.unidadeAdm.toLowerCase().includes(searchLower) ||
            pa.comprador.toLowerCase().includes(searchLower) ||
            pa.produtos.some(
              (p) =>
                p.descricao?.toLowerCase().includes(searchLower) ||
                p.centroCusto?.toLowerCase().includes(searchLower)
            );

          // 2. Filtro por data (se datas forem preenchidas)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(pa.data.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              new Date(pa.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]));

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (f === "data") {
              const dataFormatada = new Date(pa[f])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
              return this.filters[f].includes(dataFormatada);
            }

            if (f === "centroCusto") {
              return pa.produtos.some((p) =>
                this.filters[f].includes(p.centroCusto)
              );
            }

            return this.filters[f].includes(pa[f]);
          });

          // 4. Filtro por status (se não for "0")
          const statusOk =
            this.selectedFilter === "0" || pa.status === this.selectedFilter;

          return buscaTexto && dataValida && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },
    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("pedidoAvulso", ["atualizarPedidosAvulso", "atualizarPedidoAvulso"]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("centroCusto", ["atualizarCentrosCusto"]),
    ...mapActions("condicaoPagamento", ["atualizarCondicoes"]),
    ...mapActions("fornecedor", ["atualizarFornecedores","atualizarFornecedor"]),
    editar(pedidoAvulso) {
      if (!this.pedidoPodeSerEditado(pedidoAvulso)) return;
      this.atualizarPedidoAvulso(pedidoAvulso);
      if (this.isAllowed(21)) {
        this.$router.push(`/pedidoAvulso/editar`);
      } else {
        this.$router.push(`/pedidoAvulso/ver`);
      }
    },
    inativar(pedidoAvulso) {
      if (!this.pedidoPodeSerInativado(pedidoAvulso)) return;
      this.atualizarPedidoAvulso(pedidoAvulso);
      this.$router.push("/pedidoAvulso/inativar");
    },
    pedidoPodeSerEditado(pedidoAvulso) {
      return pedidoAvulso && pedidoAvulso.status === "PG";
    },
    pedidoPodeSerInativado(pedidoAvulso) {
      return (
        this.pedidoPodeSerEditado(pedidoAvulso) ||
        (this.isAdmin() && pedidoAvulso && pedidoAvulso.status !== "I")
      );
    },
    show(item) {
      getPdf(item.id, abrirJanelaPdf());
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarPedidosAvulso();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    isInactive(id) {
      return canInactivateModule(id);
    },
    isAdmin() {
      return isLoggedUserAdmin();
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
    doAjax() {
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.centrosCusto || this.centrosCusto.length == 0) {
        this.atualizarCentrosCusto();
      }
      if (!this.fornecedores || this.fornecedores.length == 0) {
      this.atualizarFornecedores();
      }
      this.atualizarCondicoes();
    },
    
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
    
    money(v) {
      const n = Number(v || 0);
      return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
  created: function () {
    this.doAjax();
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
